import { format, ISO_DATE_ONLY_FORMAT } from '@fruitful/fruitils';
import { fromZonedTime } from 'date-fns-tz';

/** Cancellations are executed at 11:59:59 PM Pacific time. */
export const CANCELLATION_TIME_ZONE = 'America/Los_Angeles';
export const CANCELLATION_END_OF_DAY = '23:59:59';

export const toCancellationDateIsoString = (date: Date | string): string =>
    fromZonedTime(
        `${format(date, ISO_DATE_ONLY_FORMAT)}T${CANCELLATION_END_OF_DAY}`,
        CANCELLATION_TIME_ZONE,
    ).toISOString();
